<template>
  <div>
    <v-row no-gutters v-if="is_required == false">
      <v-col 
            cols="auto"
            class="ml-auto">
        <v-btn text small @click="skip">Skip »</v-btn>
      </v-col>
    </v-row>
    <div class="selectBox">
      <div class="itemlist">
        <!-- <label>{{placeholder}}  <span style="color:red;" v-if="is_required">※必須</span> <span style="color:rgb(121, 121, 121);" v-if="!is_required">※任意</span>
        <strong class="error" v-if="!checkValid">{{error_message}}</strong></label> -->

        <v-dialog
          ref="dialog"
          v-model="modal"
          :return-value.sync="input_value"
          max-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <input :type="input_type" class="formItem" ref="input_value" readonly v-model="input_value" :placeholder="placeholder" v-bind="attrs"
              v-on="on">
          </template>

          <v-date-picker
            v-model="input_value"
            no-title
            scrollable
            locale="ja-jp"
            :min="min_date"
            :max="max_date"
            :allowed-dates="allowedDates"
            :day-format="day_format"
            @input="auto_submit"
            class="chatbot-date-picker"
          >
          </v-date-picker>
        </v-dialog>

        <!-- <div class="mt-5">
          <v-row no-gutters v-for="(item, index) in confirmation.items" v-bind:key="index">
            <v-col cols="auto">
              <v-checkbox
                  v-model="item.default"
                  class="mt-0 confirmation-checkbox"
                  :color="bot_setting.main_color"
                >
              </v-checkbox>
            </v-col>
            <v-col class="mt-1">
                <span style="white-space: pre-wrap;" v-html="item.value"></span>
            </v-col>
          </v-row>
          <div class="my-2 red--text darken-1 confirmation-message" v-if="confirmationValid == false">{{confirmation.error_message}}</div>
        </div> -->
      </div>
      <!-- <div class="submitBtn">
        <button :id="label_name" @click="submit" v-if="isFinalQuestion()" class="btn-final">プライバシーポリシーに<br>同意して送信</button>
        <button :id="label_name" @click="submit" v-else>次へ</button>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {

  name: "DateFieldInput",

  props: ['placeholder', 'error_message', 'pattern_match', 'bot_setting', 'is_required', 'answer_type', 'label_name', 'confirmation', 'datepicker_holidays'],

  created(){
    // if (this.answer_type == 'email'){
    //   this.input_type = 'email'
    // }
    // if (this.answer_type == 'phone-number-no-hyphen' || this.answer_type == 'phone-number-hyphen' || this.answer_type == 'phone-number-both'){
    //   this.input_type = 'tel'
    // }
    var current = new Date()
    this.min_date = current.toISOString().substr(0, 10);
    this.max_date = this.addMonths(current, 2).toISOString().substr(0, 10);
  },

  data: () =>({
    input_value: "", 
    checkValid: true,
    input_type:'text',
    confirmationValid: true,
    modal: false,
    min_date: '',
    max_date: '',
  }),

  methods: {
    skip(){
      this.$emit('skip_input_submitted')
    },
    submit(){
      // const button = document.getElementById(this.label_name)
      // button.disabled = true
      if (this.validateInput() == true){
        this.checkValid = true
          if (this.validateConfirmation() == true) {
          var selectedDate = new Date(this.input_value)
          var japanDate = selectedDate.getFullYear() + '年' + (selectedDate.getMonth() +1) + '月' + selectedDate.getDate() + '日'

          var emitValue = {user_chat_message: japanDate, user_chat_value:japanDate}
          this.$emit('text_input_submitted', emitValue)
          this.input_value = ''
        }
      }else{
        this.confirmationValid = true
        this.checkValid = false
        this.$nextTick(()=>this.$refs.input_value.focus())
      }
      // button.disabled = false
    },
    validateInput(){
      if (this.is_required == true){
        if (this.input_value == null || this.input_value == ""){
          return false
        }
      }
      if (this.pattern_match != null || this.pattern_match != ""){
        var regex = new RegExp(this.pattern_match)
        if (regex.test(this.input_value)){
          return true
        }else{
          return false
        }
      }else{
        return true
      }
    },
    validateConfirmation(){
      this.confirmationValid = true
      for(var i=0; i < this.confirmation.items.length; i++){
        if (this.confirmation.items[i].default == false){
          this.confirmationValid = false
        }
      }
      if (this.confirmationValid == true) {
        return true
      }
      return false
    },
    isFinalQuestion(){
      if (this.label_name.indexOf('final') === 0){
        return true
      }else{
        return false
      }
    },
    day_format(date){
      return new Date(date).getDate()
    },
    auto_submit(){
      this.$refs.dialog.save(this.input_value);
      // console.log(this.input_value)
      this.submit()
    },
    addMonths(date, months) {
      var d = date.getDate();
      date.setMonth(date.getMonth() + +months);
      if (date.getDate() != d) {
        date.setDate(0);
      }
      return date;
    },
    allowedDates(date){
      //var day = new Date(date).getDay()
      //if ( day!=0 && day!=6 && this.datepicker_holidays.indexOf(date) === -1 && window.rt_holidays.indexOf(date) === -1){
      if ( window.rt_holidays.indexOf(date) === -1){
        return date
      }
      return false
    }
  }

}
</script>